import { ssrApi } from 'api/ssr';
import { AboutUsPage } from 'components/template/about-us';
import { IQuestion, IVariables } from 'constants/types';

export default function AboutPage({
  data,
  questions,
}: {
  data: IVariables;
  questions: IQuestion[];
}) {
  return <AboutUsPage data={data} questions={questions} />;
}

export async function getServerSideProps() {
  const data = await ssrApi.variables.getById('about-us');

  const { results } = await ssrApi.questions.list({ limit: 20 });

  return {
    props: { data, questions: results },
  };
}
